import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Checkbox from '../../../components/Checkbox/Checkbox';
import CheckboxGroup from '../../../components/Checkbox/CheckboxGroup';
import CircledIcon from '../../../components/CircledIcon';
import { RadioGroup } from '../../../components/Radio';
import SelectableBankCard, {
  SelectableDefaultBankCard,
} from '../../../components/SelectableBankCard';
import Support from '../../../components/Support';
import SupportMobile from '../../../components/Support/SupportMobile';
import useModal from '../../../hooks/useModal';
import { addOrRemoveMonthsToGivenDate, formatDate } from '../../../utils/utils';
import AddNewBankModal from '../retireOnlineModals/addNewBankModal/AddNewBankModal';

export type StepProps = {
  data: any;
  collectStepData: (data: any) => void;
};

const RetireOnlineDirectDepositStep = ({
  data,
  collectStepData,
}: StepProps) => {
  const [showModal, handleShowModal, handleCloseModal] = useModal();
  const [value, setValue] = useState<string[]>([]);

  const handleBankOptionChange = (e: string | number) => {
    collectStepData({
      ...data,
      selectedBankOption: e,
    });
  };

  const handleNewBank = (bank: any) => {
    collectStepData({
      ...data,
      banksOptions: [...data.banksOptions, bank],
    });
  };

  const handleChange = (event: any, values: string[]) => {
    setValue(values);
  };

  const date = new Date();
  const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

  return (
    <Row className="p-0">
      <section className="col-12 col-lg-9">
        <div className="d-flex flex-row justify-content-between align-items-center">
          <h5 className={'mt-12 text-sm-20-lg-24'}>Direct Deposit</h5>
          <div className={'mt-12 text-sm-20-lg-24 d-lg-none'}>
            <SupportMobile>
              <div className="p-0 mt-4">
                <span className="fw-bold text-caption">
                  Retirement Case Administrator
                </span>
                <div className="mt-4">
                  <CircledIcon
                    icon={light('user-headset')}
                    label="Jessica Wright"
                  />
                </div>
                <div className="mt-4">
                  <CircledIcon
                    icon={light('phone')}
                    label="1-800-888-8888 x 1234"
                  />
                </div>
              </div>
            </SupportMobile>
          </div>
        </div>
        <div className={'text-caption lh-xs text-ligther-grey fw-light'}>
          <p>Select from an existing account or add a new one</p>
        </div>
        <section className="mt-12">
          <Container className="p-0 d-flex flex-wrap">
            <RadioGroup
              name={'banks'}
              value={data.selectedBankOption}
              onChange={handleBankOptionChange}
            >
              {data.banksOptions.map((bank: any, i: number) => (
                <SelectableBankCard
                  key={i}
                  item={bank}
                  className={'mb-7 mb-lg-0 me-lg-7'}
                  selected={data.selectedBankOption === bank.id}
                />
              ))}
              <SelectableDefaultBankCard onClick={handleShowModal} />
              <AddNewBankModal
                showModal={showModal}
                handleClose={handleCloseModal}
                handleAddNewBank={handleNewBank}
                banks={data.banksOptions}
              />
            </RadioGroup>
          </Container>
          <Row className={'m-0 mt-7 p-0'}>
            <span className="p-0 fw-light text-sub1">{`Effective Date: ${formatDate(
              addOrRemoveMonthsToGivenDate(new Date(firstDay), 1)
            )}`}</span>
          </Row>
          {data.selectedBankOption && (
            <Row className={'m-0 mt-11 p-0'}>
              <Col className="d-flex flex-row col-lg-8 p-0">
                <CheckboxGroup
                  name={'no-labels'}
                  value={value}
                  onChange={handleChange}
                >
                  <Checkbox value={'1'} id={'2'} variant="sm" />
                </CheckboxGroup>
                <span className="ps-8 text-caption text-ligther-grey fw-light lh-xs">
                  I authorized that my benefit payments be deposited directly
                  into the account named above until I instruct otherwise. If an
                  incorrect amount is deposited into my account, I authorize the
                  appropriate adjustment to my account.
                </span>
              </Col>
            </Row>
          )}
        </section>
      </section>
      <div className="d-none d-lg-flex justify-content-lg-end col-lg-3">
        <section className="mt-12">
          <Support>
            <div className="p-0 mt-4">
              <span className="fw-bold text-caption">
                Retirement Case Administrator
              </span>
              <div className="mt-4">
                <CircledIcon
                  icon={light('user-headset')}
                  label="Jessica Wright"
                />
              </div>
              <div className="mt-4">
                <CircledIcon
                  icon={light('phone')}
                  label="1-800-888-8888 x 1234"
                />
              </div>
            </div>
          </Support>
        </section>
      </div>
    </Row>
  );
};

export default RetireOnlineDirectDepositStep;
